import { Skeleton } from "@/components/ui/skeleton"

interface AdminLoadingSkeletonProps {
  rows?: number
  height?: string
  variant?: "table" | "card" | "mixed"
}

export function AdminLoadingSkeleton({
  rows = 5,
  height = "h-14",
  variant = "table",
}: AdminLoadingSkeletonProps) {
  if (variant === "card") {
    return (
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} className="h-32 rounded-xl" />
        ))}
      </div>
    )
  }

  if (variant === "mixed") {
    return (
      <div className="space-y-4">
        <Skeleton className="h-32 rounded-xl" />
        <div className="grid gap-4 md:grid-cols-2">
          <Skeleton className="h-40 rounded-xl" />
          <Skeleton className="h-40 rounded-xl" />
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-2">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className={`${height} rounded-lg`} />
      ))}
    </div>
  )
}
